const primaryColor = 'rgba(239, 210, 165, 1)'; // #efd2a5 (Light Beige)
const secondaryColor = 'rgba(176, 38, 28, 1)'; // #b0261c (Bright Red)
const backgroundColor = 'rgba(255, 255, 255, 1)'; // White
const borderColor = 'rgba(129, 154, 71, 1)'; // #819a47 (Lighter Green)

export const mainColors = {
  primaryColor,
  secondaryColor,
  backgroundColor:'rgba(129, 154, 71, 1)',
  borderColor,
};

export const theme = {
  headline: {
    fontFamily: 'Inter',
    color: primaryColor,
  },
  text: {
    fontFamily: 'Inter',
    color: primaryColor,
  },
  spacer: {
    color: 'rgba(0, 0, 0, 0)', // Transparent
  },
  button: {
    fontFamily: 'Inter',
    color: primaryColor,
    borderColor: primaryColor,
    backgroundColor: secondaryColor,
  },
  rank: {
    baseColor: secondaryColor,
  },
  image: {
    backgroundColor: 'rgba(0, 0, 0, 0)', // Transparent
  },
  field: {
    fontFamily: 'Inter',
    color: 'rgba(51, 14, 18, 1)', // #330e12 (Dark Maroon)
    borderColor: backgroundColor,
    backgroundColor: backgroundColor,
  },
  social: {
    color: primaryColor,
  },
  survey: {
    color: primaryColor,
    borderColor: borderColor,
    backgroundColor: 'rgba(94, 28, 37, 1)', // #5e1c25 (Dark Red)
  },
  wheel: {
    fontFamily: 'Inter',
    color: primaryColor,
    borderColor: 'rgba(94, 28, 37, 1)', // #5e1c25 (Dark Red)
    backgroundColor: borderColor,
    secondaryBackgroundColor: secondaryColor,
  },
  voucher: {
    fontFamily: 'Inter',
    fontWeight: 'bold',
    color: primaryColor,
    borderColor: primaryColor,
  },
  checkbox: {
    color: primaryColor,
    borderColor: 'rgba(255, 255, 255, 0)', // Transparent
    checkboxColor: primaryColor,
    backgroundColor: 'rgba(94, 28, 37, 1)', // #5e1c25 (Dark Red)
  },
};

export default {
  theme,
  mainColors,
};
